// Fase 168 (Connect + WAIA) — las extras del alta de Meta (Embedded Signup), por versión.
//
// Meta depreca Embedded Signup v2 (y v3) el 15/10/2026. Doc vigente:
//   developers.facebook.com/documentation/business-messaging/whatsapp/embedded-signup/versions/
//     v4: `extras: {} // The extras object is purposely empty for v4.`; la versión la pone la
//     Login for Business Configuration con productos elegidos.
//   …/embedded-signup/version-4/: «Onboarding WhatsApp Business app users continues to be
//     supported through the feature_type parameter.»
// v4 = setup:{} + featureType (Coexistence lo necesita) y SIN sessionInfoVersion (marca de v2).
//
// La versión NO se compila. Al abrir el modal se lee `/meta-es.json` del mismo origen:
//   {"version":"v2"}                         → rollback a v2, sin rebuild ni restart
//   {"version":"v4","configIdCoex":"…","configIdCloud":"…"} → config v4 nueva
// Si el archivo no existe (nginx devuelve el index.html) o falla → v4 con los ids de siempre.
// Rollback: docker exec whaticket-community-frontend-1 sh -c 'echo {\"version\":\"v2\"} > /var/www/public/meta-es.json'
export const ES_V4_MARKER = "meta-es:v4-ready";
export const ES_DEFAULT_VERSION = "v4";

const FEATURE_TYPE = {
	meta: "whatsapp_embedded_signup",
	meta_coexistence: "whatsapp_business_app_onboarding",
};

export const buildSignupExtras = (provider, version) => {
	const featureType = FEATURE_TYPE[provider] || FEATURE_TYPE.meta;
	return version === "v2"
		? { setup: {}, featureType, sessionInfoVersion: "3" }
		: { setup: {}, featureType };
};

const digits = v => (typeof v === "string" && /^\d{6,25}$/.test(v) ? v : null);

export const parseSignupConfig = body => {
	const b = body && typeof body === "object" ? body : {};
	return {
		version: b.version === "v2" ? "v2" : "v4",
		configIdCoex: digits(b.configIdCoex),
		configIdCloud: digits(b.configIdCloud),
		source: "file",
		marker: ES_V4_MARKER,
	};
};

const DEFAULT_CONFIG = { version: ES_DEFAULT_VERSION, configIdCoex: null, configIdCloud: null, source: "default", marker: ES_V4_MARKER };
let current = DEFAULT_CONFIG;

// Al abrir el modal (nunca en el clic: FB.login tiene que correr dentro del gesto). Nunca rechaza.
export const loadSignupConfig = async (fetchImpl = typeof fetch !== "undefined" ? fetch : null) => {
	try {
		if (!fetchImpl) throw new Error("no_fetch");
		const r = await fetchImpl(`/meta-es.json?ts=${Date.now()}`, { cache: "no-store" });
		if (!r.ok) throw new Error(`http_${r.status}`);
		current = parseSignupConfig(JSON.parse(await r.text()));
	} catch (_) {
		current = DEFAULT_CONFIG;
	}
	return current;
};

export const currentSignupConfig = () => current;
export const resetSignupConfigForTests = () => {
	current = DEFAULT_CONFIG;
};

// v4 suma FINISH_OBO_MIGRATION / FINISH_GRANT_ONLY_API_ACCESS (mismos nombres que v2 para el resto).
export const FINISH_EVENTS = new Set([
	"FINISH",
	"FINISH_ONLY_WABA",
	"FINISH_WHATSAPP_BUSINESS_APP_ONBOARDING",
	"FINISH_OBO_MIGRATION",
	"FINISH_GRANT_ONLY_API_ACCESS",
]);

// Clasifica el evento WA_EMBEDDED_SIGNUP para v2 y v4. En v4 el error que la persona reporta
// llega como CANCEL con error_message (doc de implementación, «User reported errors»).
export const classifySignupEvent = data => {
	if (!data || data.type !== "WA_EMBEDDED_SIGNUP") return "ignore";
	if (FINISH_EVENTS.has(data.event)) return "finish";
	if (data.event === "ERROR" || (data.event === "CANCEL" && data.data && data.data.error_message)) return "error";
	if (data.event === "CANCEL") return "cancel";
	return "ignore";
};
